import { render, staticRenderFns } from "./IncorporationFormsDetails.vue?vue&type=template&id=58d081a6&scoped=true&"
import script from "./IncorporationFormsDetails.vue?vue&type=script&lang=js&"
export * from "./IncorporationFormsDetails.vue?vue&type=script&lang=js&"
import style0 from "./IncorporationFormsDetails.vue?vue&type=style&index=0&id=58d081a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d081a6",
  null
  
)

export default component.exports